import React from "react";
import { useSearchParams } from "react-router-dom";
import { axiosInstance } from "../api/axiosInstance";

/**
 * Custom hook to load metadata from URL meta (pre_reg_token) parameter.
 * Calls the metadata endpoint to retrieve and mark as used (single-use).
 * 
 * Returns an object with:
 * - data: {firstName, lastName, phone, email, reference, notes} or null
 * - isLoading: boolean
 * - error: error message or null
 */
export const useMetadata = () => {
  const [queryParams] = useSearchParams();
  const [state, setState] = React.useState({
    data: null,
    isLoading: false,
    error: null,
  });

  React.useEffect(() => {
    const preRegToken = queryParams.get("meta");
    
    if (!preRegToken) {
      return;
    }

    const fetchMetadata = async () => {
      setState({ data: null, isLoading: true, error: null });
      try {
        const response = await axiosInstance.get(`/metadata/${preRegToken}`);
        
        // Extract the useful fields (remove the status field added by API response)
        const { status, ...metadataBlob } = response.data;
        
        setState({
          data: metadataBlob,
          isLoading: false,
          error: null,
        });
      } catch (err) {
        setState({
          data: null,
          isLoading: false,
          error: err.message || "Failed to load metadata",
        });
      }
    };

    fetchMetadata();
  }, [queryParams]);

  return state;
};
